import React, { useEffect, useState } from 'react';
import apiService from '../services/api';
import './DailySpiritualInfoBanner.css';

// Helper function to safely find URLs in text and convert them to clickable React links
const renderTextWithLinks = (text) => {
  if (!text) return null;
  
  // Regex to match URLs starting with http:// or https://
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  // Split the text by URLs. The () in the regex ensures the URL is kept in the array.
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => {
    if (part.match(urlRegex)) {
      return (
        <a 
          key={index} 
          href={part} 
          target="_blank" 
          rel="noopener noreferrer"
          className="banner-inline-link"
        >
          {part}
        </a>
      );
    }
    return part; // Return standard text
  });
};

const DailySpiritualInfoBanner = () => {
  const [item, setItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCurrentInfo = async () => {
      try {
        const response = await apiService.getCurrentDailySpiritualInfo();
        if (response.success) {
          setItem(response.data || null);
        }
      } catch (error) {
        // Keep this silent for homepage stability.
        setItem(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCurrentInfo();
  }, []);

  if (isLoading) {
    return (
      <section className="daily-spiritual-banner" aria-live="polite">
        <div className="daily-spiritual-banner__inner">
          <span className="daily-spiritual-banner__label">Daily Spiritual Update</span>
          <p className="daily-spiritual-banner__placeholder">Loading today's update...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="daily-spiritual-banner" aria-live="polite">
      <div className="daily-spiritual-banner__inner">
        <span className="daily-spiritual-banner__label">Daily Spiritual Update</span>

        {item ? (
          <>
            <h3 className="daily-spiritual-banner__title">{item.title}</h3>
            {item.dateLabel ? (
              <p className="daily-spiritual-banner__date">{item.dateLabel}</p>
            ) : null}
            
            {/* USE THE HELPER FUNCTION HERE */}
            <p className="daily-spiritual-banner__content">
              {renderTextWithLinks(item.content)}
            </p>
            
          </>
        ) : (
          <p className="daily-spiritual-banner__placeholder">
            Daily spiritual information or panchang will be published here.
          </p>
        )}
      </div>
    </section>
  );
};

export default DailySpiritualInfoBanner;